export default __webpack_public_path__ + "static/media/New_Analysieren.85eeda67.png";